var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useSelector } from 'react-redux';
import { BlameLogType } from '@debbie/common/dist/blamelog';
import UserInfoEntity from './UserInfoEntity';
const CarRegistrationNumber = (props) => {
    const { details } = props.user;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(React.Fragment, null,
        React.createElement(UserInfoEntity
        // TODO: Lang
        , { 
            // TODO: Lang
            title: 'Registreringsnummer', value: details.carRegistrationNumber, onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                yield props.patchUser({
                    carRegistrationNumber: val,
                }, {
                    details: val,
                    type: BlameLogType.DebtorUpdateCarRegistrationNumber,
                });
            }), removable: true })));
};
export default CarRegistrationNumber;
//# sourceMappingURL=UserCarRegistrationNumber.js.map